/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { GetStateTaxPaymentResponseDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchStateTaxPaymentsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags StateTaxPayment
   * @name StateTaxPaymentGet
   * @summary Returns ach state tax payment information
   * @request GET:/achStateTaxPayments/{achPaymentUniqueId}
   */
  stateTaxPaymentGet = (
    achPaymentUniqueId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<GetStateTaxPaymentResponseDto, any>({
      path: `/achStateTaxPayments/${achPaymentUniqueId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
